import axios from 'axios';
import { showTabs, selectTab } from '../../common/tab/tabActions';
import consts from '../../consts';
import { setErroAPI, setSuccess } from '../../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../../common/dateFormat/DateFormat';
import FormatUtils from '../../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'COMPETICAO_CATEGORIA_MODO_TELA',
        payload: {
			modo: modo,
			registro: {
				...registro
			}
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('competicaoCategoriaForm', {
			...registro,
			vagas: FormatUtils.formatarValorTela(registro.vagas, 0),
				data_inicio_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicio_inscricao)),
				data_fim_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_fim_inscricao))
		})
    ];
}

export function setAguardando(aguardando) {
    return {
        type: 'COMPETICAO_CATEGORIA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/competicaoCategoria`);
    return {
        type: 'COMPETICAO_CATEGORIA_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
	console.log(registro)
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/competicaoCategoria`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id,
				vagas: FormatUtils.formatarValorTela(registro.vagas, 0),
				data_inicio_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicio_inscricao)),
				data_fim_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_fim_inscricao))
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			console.log(registro)
			axios.put(`${consts.API_URL}/competicaoCategoria`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id,
				vagas: FormatUtils.formatarValorTela(registro.vagas, 0),
				data_inicio_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_inicio_inscricao)),
				data_fim_inscricao: DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(registro.data_fim_inscricao))
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return dispatch => {
        axios.delete(`${consts.API_URL}/competicaoCategoria?id=${registro.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaCategoria() {
    const request = axios.get(`${consts.API_URL}/categoria/listarSelect`);
    return {
        type: 'COMPETICAO_CATEGORIA_CATEGORIA_SELECT_LISTADO',
        payload: request
    };
}

export function getListaCompeticao() {
    const request = axios.get(`${consts.API_URL}/competicao/listarSelect`);
    return {
        type: 'COMPETICAO_CATEGORIA_COMPETICAO_SELECT_LISTADO',
        payload: request
    };
}